import './js/scaleRoot.2.js';
import './js/scrollFrame.2.js';
import './js/scrollwatch.js';
// import './js/_language.js';
import './js/setup.js';
import './scss/main.scss';
import lozad from 'lozad';
const observer = lozad('.lazyload', {
  loaded: function (el) {
    el.classList.add('is-loaded');
  }
});
observer.observe();

$('a[href="#"]').click(function (event) {
  var hrefValue = $(this).attr('href');
  if (hrefValue === '#') {
    console.log('Disable href 2');
    event.preventDefault();
  };
});

for (let i = 0; i < 80; i++) {
  let newDiv = $("<i>");
  // newDiv.addClass("snow");
  $(".effect #leaves").prepend(newDiv);
};